import { prop, propArray, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Case } from "../../cases/_types/case";
import { MailMessageRecipient } from "./mail-message-receipt";
import { Relationship } from "src/app/core/jsonapi/relationship";
import { RelationshipArray } from "src/app/core/jsonapi/relationship-array";
import { MailAccount } from "./mail-account";
import { MailMessageAttachment } from "./mail-message-attachment";

export enum MailMessageState {
    Pending = "Pending",
    Error = "Error",
    Sent = "Sent"
}

export enum MailProcessedStatus
{
    NoRequired = "NoRequired",
    Pending = "Pending",
    Success = "Success",
    Error = "Error"
}

export class MailMessage extends Resource {
    public override type = 'mailMessages';

    @prop()
    public mailAccountId?: string;

    @propObject(MailAccount)
    public mailAccount?: MailAccount | null;

    @prop()
    public caseId!: string;

    public case?: Case;

    @prop()
    public from!: string;

    @prop()
    public subject!: string;

    @prop()
    @required()
    public content!: string;

    @prop()
    public state: MailMessageState = MailMessageState.Pending;

    @prop()
    public processedStatus: MailProcessedStatus = MailProcessedStatus.NoRequired;

    @prop()
    @required()
    public stateDate: Date = new Date();


    @prop()
    public stateInfo?: string;

    @propArray()
    public recipients: MailMessageRecipient[] = [];


    @prop()
    public type_comunication: string = "";


    @prop()
    public template_id?: number;

    @prop()
    public to?: string[] = [];

    @prop()
    public cc?: string[] = [];

    @prop()
    public bcc?: string[] = [];


    @propArray()
    public attachments: MailMessageAttachment[] = [];

    //esto de debajo para que????
    @prop()
    public tos?: string;

    @prop()
    public ccs?: string;

    @prop()
    public bccs?: string;

    @prop()
    public recipientType?: string;
    @prop()
    public mailAddress?: string;

}